// assets
import { PermALL } from '../../app/hooks/premissionScreen'
import { categoryMenuItem } from './categoryAll'
import { companyMenuItem } from './company'
import { customerMenuItem } from './customer'
import { generalMenuItem } from './general'
import { orderMenuItem } from './order'
import { reportMenuItem } from './report'
import { staffAccountMenuItem } from './staffAccount'

const managers = {
  id: 'all-manager',
  // title: 'Quản lý',
  type: 'group',
  premissions: PermALL,
  children: [
    ...generalMenuItem,
    ...orderMenuItem,
    staffAccountMenuItem,
    customerMenuItem,
    ...companyMenuItem,
    ...categoryMenuItem,
    ...reportMenuItem
  ]
}

export default managers
